import script from "./dashboard-overview-total-builds.vue?vue&type=script&lang=ts&setup=true"
export * from "./dashboard-overview-total-builds.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__